module.exports = __webpack_public_path__ + "img/heroes_adoption.f19d5db0.png";